import React, { useEffect, useState } from 'react';
import offIcon from '../../Assets/Images/rewamp/off percent.svg';

const COUPON_API_URL = `${process.env.REACT_APP_QUANTUMURL}coupons/validate?category=CONSULTATION&coupon_code=CB_CONS100`;

const IntroSection = ({ items = [], report_count, type }) => {
  const [badgeHovered, setBadgeHovered] = useState(false);
  const [coupon, setCoupon] = useState(null);
  const [couponCopied, setCouponCopied] = useState(false);

  useEffect(() => {
    let active = true;
    fetch(COUPON_API_URL)
      .then((res) => res.json())
      .then((data) => { if (active && data?.valid) setCoupon(data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const handleCopyCoupon = () => {
    if (!coupon?.couponCode) return;
    navigator.clipboard?.writeText(coupon.couponCode).then(() => {
      setCouponCopied(true);
      setTimeout(() => setCouponCopied(false), 2000);
    });
  };

  if (!items.length) return null;

  const {
    heading,
    subheading,
    description,
    button,
    button1,
    onButtonClick,
    onSecondButtonClick,
    image
  } = items[0];

  const languages = [
    { name: 'English', native: null },
    { name: 'Hindi', native: 'हिंदी' },
    { name: 'Odia', native: 'ଓଡ଼ିଆ' },
    { name: 'Bengali', native: 'বাংলা' },
    { name: 'Tamil', native: 'தமிழ்' },
    { name: 'Telugu', native: 'తెలుగు' },
    { name: 'Marathi', native: 'मराठी' },
    { name: 'Kannada', native: 'ಕನ್ನಡ' },
  ];

  const gradientText = {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '25px',
    letterSpacing: '0.03em',
    color: 'var(--color-brand-green)',
  };
  const navyText = { color: 'var(--color-brand-primary)' };

  return (
    <div className="mx-auto w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');

        .intro-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 52px;
          line-height: 60px;
          color: var(--color-brand-primary);
          margin-bottom: 6px;
        }

        .intro-subheading {
          font-weight: 700;
          font-size: 30px;
          line-height: 50px;
          color: var(--color-brand-green);
          margin: 0 0 4px 0;
        }

        .intro-desc {
          font-weight: 500;
          font-size: 16px;
          line-height: 1.6;
          color: var(--color-text-subheading);
          margin-top: 0;
          margin-bottom: 20px;
          max-width: 600px;
        }

        .btn-primary {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          background: var(--color-brand-primary);
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-primary:hover { background: var(--color-brand-primary-hover); }

        .btn-outline-wrapper {
          display: inline-block;
          border-radius: 999px;
        }

        .btn-outline {
          font-weight: 600;
          font-size: 16px;
          color: var(--color-brand-primary);
          background: #ffffff;
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-outline:hover { background: #EAF3FA; }

        /* REPORTS BADGE */
        .reports-badge {
          min-width: clamp(120px, 14vw, 170px);
          background: #ffffff;
          border: 1px solid #80DAF1;
          border-radius: 8px;
          padding: 10px 16px;
          color: var(--color-brand-primary);
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          text-align: left;
          animation: glowPulse 3.5s ease-in-out infinite,
                     floatBadge 3.5s ease-in-out infinite;
        }

        .reports-badge:hover {
          transform: scale(1.08);
        }

        .badge-count {
          font-weight: 700;
          font-size: clamp(18px, 2.5vw, 28px);
          line-height: 1.1;
          color: var(--color-brand-green);
        }

        .badge-label {
          font-weight: 500;
          font-size: clamp(11px, 1.2vw, 16px);
          line-height: 1.25;
          margin-top: 2px;
        }

        /* LANGUAGE BADGE */
        .lang-badge {
          border-radius: 12px;
          padding: 12px 16px;
          margin-bottom: 20px;
          max-width: 600px;
          background: #FFFFFF;
          border: 1px solid #C9EEF8;
          box-shadow: 0px 4px 10px 0px #80DAF180;
        }

        .lang-badge p {
          margin: 0;
        }

        /* COUPON BANNER */
        .coupon-banner {
          display: flex;
          align-items: center;
          gap: 16px;
          max-width: 720px;
          width: 100%;
          margin-bottom: 20px;
          padding: 14px 20px;
          border-radius: 16px;
          background: #ffffff;
          border: 1px solid #C9EEF8;
          box-shadow: 0px 4px 10px 0px #80DAF180;
        }

        .coupon-icon {
          flex-shrink: 0;
          width: 76px;
          height: 76px;
          object-fit: contain;
        }

        .coupon-text {
          flex: 1 1 auto;
          min-width: 0;
        }

        .coupon-text-line1 {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 16px;
          line-height: 1;
          letter-spacing: 0;
          color: var(--color-brand-primary);
          white-space: nowrap;
          margin: 0 0 6px 0;
        }

        .coupon-text-line2 {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 20px;
          line-height: 1;
          letter-spacing: 0;
          white-space: nowrap;
          color: var(--color-brand-green);
          margin: 0;
        }

        .coupon-divider {
          width: 1.5px;
          align-self: stretch;
          background: #C9EEF8;
          flex-shrink: 0;
        }

        .coupon-code-block {
          flex-shrink: 0;
          text-align: center;
        }

        .coupon-code-label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.08em;
          color: var(--color-brand-primary);
          margin: 0 0 4px 0;
        }

        .coupon-code-box {
          font-family: 'Inter', monospace;
          font-weight: 700;
          font-size: 14px;
          color: var(--color-brand-primary);
          background: #ffffff;
          border: 1.5px dashed #00B5E2;
          border-radius: 8px;
          padding: 4px 12px;
          cursor: pointer;
          white-space: nowrap;
        }

        .coupon-code-caption {
          margin: 4px 0 0 0;
        }

        .coupon-code-caption-label {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 12px;
          line-height: 1;
          letter-spacing: 0;
          color: var(--color-brand-primary);
        }

        .coupon-code-caption-free {
          font-family: 'Inter', sans-serif;
          font-weight: 900;
          font-style: italic;
          font-size: 14px;
          line-height: 1;
          letter-spacing: 0;
          color: var(--color-brand-green);
        }

        /* Below this, the icon + code box no longer leave enough room to force
           the headline onto one line without clipping it — let it wrap
           instead, which reads cleanly on 2 lines rather than cutting off. */
        @media (max-width: 1300px) {
          .coupon-text-line1, .coupon-text-line2 { white-space: normal; }
        }

        @media (max-width: 640px) {
          .coupon-banner { flex-wrap: wrap; justify-content: center; text-align: center; }
          .coupon-divider { display: none; }
          .coupon-code-block { flex-basis: 100%; }
        }

        /* ANIMATIONS */
        @keyframes glowPulse {
          0%, 100% { box-shadow: 0px 4px 10px 0px #80DAF180; }
          50%       { box-shadow: 0px 4px 18px 2px #80DAF1; }
        }

        @keyframes floatBadge {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-6px); }
        }

        /* LAYOUT */
        .intro-wrapper {
          background-color: #ffffff;
          background-image: var(--section-bg-gradient);
          display: flex;
          justify-content: space-between;
          padding: 20px max(64px, calc(50% - 656px));
          overflow: hidden;
        }

        .intro-left {
          max-width: 50%;
          display: flex;
          flex-direction: column;
          margin-top: 48px;
        }

        .intro-right {
          width: 48%;
          display: flex;
          justify-content: flex-end;
        }

        .intro-btns {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          align-items: center;
        }

        .intro-image-wrapper {
          position: relative;
          width: 100%;
        }

        .intro-image-container {
          width: 100%;
          height: 510px;
          padding-bottom: 50px;
          box-sizing: border-box;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .intro-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: scale(1) translate(17px, 20px);
        }

        .badge-overlay {
          position: absolute;
          top: 10px;
          left: -30px;
          z-index: 2;
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .intro-wrapper { padding: 30px; }
          .intro-left { max-width: 100%; }
          .intro-right { width: 100%; }
          .intro-image-container { height: 300px; padding-bottom: 20px; }
          .intro-image { transform: scale(1.1) translate(10px, 20px); }
          .badge-overlay { left: 0px; transform: scale(0.9); }
          .lang-badge { max-width: 100%; }
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .intro-wrapper { flex-direction: column; padding: 24px 20px; }
          .intro-left { align-items: center; text-align: center; margin-top: 0; }
          .intro-heading { font-size: 32px; line-height: 38px; }
          .intro-subheading { font-size: 20px; line-height: 28px; }
          .intro-desc { max-width: 100%; }
          .intro-right { width: 100%; margin-top: 20px; }
          .intro-image-container { height: 380px; padding-bottom: 0; justify-content: center; }
          .intro-image { transform: scale(1.15) translate(0px, 10px); }
          .badge-overlay { top: 8px; left: 8px; transform: scale(0.65); transform-origin: top left; }
          .lang-badge { max-width: 100%; }
          .intro-btns { justify-content: center; }
        }

        /* SMALL MOBILE */
        @media (max-width: 480px) {
          .intro-heading { font-size: 26px; line-height: 32px; }
          .intro-subheading { font-size: 16px; }
          .intro-image-container { height: 320px; padding-bottom: 0; }
          .intro-image { transform: scale(1.05) translate(0px, 5px); }
          .badge-overlay { transform: scale(0.55); transform-origin: top left; }
        }
      `}</style>

      <div className="intro-wrapper">

        {/* LEFT */}
        <div className="intro-left">
          <h1 className="intro-heading">{heading}</h1>
          <p className="intro-subheading">{subheading}</p>
          <p className="intro-desc">{description}</p>

          {/* Language Badge */}
          <div className="lang-badge">
            <p style={{ margin: 0, ...gradientText }}>
              {/* Figma: labels, English names and bullets in navy; "8 languages" and native scripts in green */}
              <span style={{ ...gradientText, ...navyText, fontWeight: 600 }}>{'Now available in '}</span>
              <span style={{ ...gradientText, fontWeight: 700 }}>{'8 languages: '}</span>
              {languages.map((lang, idx) => (
                <span key={lang.name}>
                  {idx > 0 && <span style={{ ...gradientText, ...navyText, fontWeight: 400 }}>{' • '}</span>}
                  {lang.native ? (
                    <span>
                      <span style={{ ...gradientText, fontWeight: 700 }}>{lang.native}</span>
                      <span style={{ ...gradientText, ...navyText, fontWeight: 400 }}>{` (${lang.name})`}</span>
                    </span>
                  ) : (
                    <span style={{ ...gradientText, ...navyText, fontWeight: 700 }}>{lang.name}</span>
                  )}
                </span>
              ))}
            </p>
          </div>

          {/* Coupon Promotion — shown only when the coupon API confirms it's currently valid */}
          {coupon && (
            <div className="coupon-banner">
              <img src={offIcon} alt="" className="coupon-icon" />
              <div className="coupon-text">
                <p className="coupon-text-line1">Use Coupon Code to Get</p>
                <p className="coupon-text-line2">100% OFF on Doctor Consultation !</p>
              </div>
              <span className="coupon-divider" />
              <div className="coupon-code-block">
                <p className="coupon-code-label">USE COUPON CODE</p>
                <div className="coupon-code-box" onClick={handleCopyCoupon} title="Click to copy">
                  {couponCopied ? 'Copied!' : coupon.couponCode}
                </div>
                <p className="coupon-code-caption">
                  <span className="coupon-code-caption-label">Get expert guidance </span>
                  <span className="coupon-code-caption-free">FREE!</span>
                </p>
              </div>
            </div>
          )}

          <div className="intro-btns">
            {button && (
              <button className="btn-primary" onClick={onButtonClick}>
                {button}
              </button>
            )}

            {button1 && (
              <span className="btn-outline-wrapper">
                <button className="btn-outline" onClick={onSecondButtonClick}>
                  {button1}
                </button>
              </span>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="intro-right">
          <div className="intro-image-wrapper">

            {image && (
              <div className="intro-image-container">
                <img src={image} alt={heading} className="intro-image" />
              </div>
            )}

            {report_count !== undefined && (
              <div className="reports-badge badge-overlay">
                <div className="badge-count">{report_count}</div>
                <div className="badge-label">
                  {type === "triage" ? "Triages Done" : "Reports Generated"}
                </div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default IntroSection;